import { Component, OnInit } from '@angular/core';
import { ThemeCustomizerService } from '../../common/theme-customizer/theme-customizer.service';

interface DepartmentTab {
  id: string;
  label: string;
}

interface FactItem {
  title: string;
  value: string;
}

interface OutcomeItem {
  title: string;
  description: string;
}

interface LabItem {
  title: string;
  image: string;
  description: string;
}

interface ProgrammeItem {
  sno: number;
  name: string;
  duration: string;
}

interface ActivityItem {
  sno: number;
  activity: string;
  date: string;
  description: string;
}

interface MouItem {
  sno: number;
  organization: string;
  date: string;
  purpose: string;
}

interface PlacementStudentItem {
  sno: number;
  studentName: string;
  designation: string;
  companyName: string;
}

interface PlacementYearGroup {
  academicYear: string;
  records: PlacementStudentItem[];
}

interface ActivityPhotoItem {
  image: string;
  alt: string;
}

interface ValueAddedCourseItem {
  sno: number;
  courseName: string;
  description: string;
  duration: string;
}

interface AlumniItem {
  image: string;
  alt: string;
  batch: string;
  name: string;
  designation: string;
  organization: string;
  location?: string;
}

interface AchievementItem {
  sno: number;
  studentNames: string[];
  eventName: string;
  collegeName: string;
  level: string;
  eventDate: string;
  awardName: string;
}
interface UniversityRankHolderItem {
  batch: string;
  name: string;
  rank: string;
  photo: string;
  alt: string;
}
interface NptelRecordItem {
  staffName: string;
  subject: string;
  grade: string;
  session: string;
}

interface ConferenceItem {
  sno: number;
  conferenceName: string;
  paperTitle: string;
  authors: string[];
  collegeName: string;
  date: string;
}

interface PatentItem {
  sno: number;
  academicYear: string;
  name: string;
  category: string;
  inventionTitle: string;
  applicationNumber: string;
  publicationDate: string;
  status: string;
}
interface MouPhotoItem {
  image: string;
  alt: string;
  note: string;
}
interface AlumniPhotoItem {
  image: string;
  alt: string;
  note: string;
}
interface IndustrialVisitItem {
  sno: number;
  date: string;
  industry: string;
  studentsBenefitted: number;
  image: string;
  alt: string;
}
interface JournalPublicationItem {
  sno: number;
  authors: string[];
  title: string;
  journalName: string;
  issueVolume: string;
  monthYear: string;
}

interface FundReceivedItem {
  sno: number;
  staffName: string;
  amount: string;
  source: string;
  date: string;
  purpose: string;
}
interface DistinguishedAlumniItem {
  image: string;
  alt: string;
  name: string;
  batch: string;
  workingAddress: string;
  position: string;
}
@Component({
  selector: 'app-orders-page',
  templateUrl: './orders-page.component.html',
  styleUrls: ['./orders-page.component.scss']
})
export class OrdersPageComponent implements OnInit {
  isToggled = false;
  selectedTab = 'tab1';

  departmentName = 'Department of Computer Science & Engineering';
  establishedYear = '2011';
  programmeSummary = '1 UG + 1 PG Programme';
  contactEmail = 'hodcse@fmcet.ac.in';

 admissionNotice =
    'Admissions open for 2026 : B.E. (Civil), B.E. (CSE), B.E. (CSE - AI & ML), B.E. (CSE - CS),B.Tech. (AI & DS), B.E. (ECE), B.E. (EEE), B.E. (Mechanical), MBA,M.E. (CSE), M.E. (Embedded System Technologies),M.E. (Thermal Engineering), M.E. (Environmental Engineering)';
      
  tabs: DepartmentTab[] = [
    { id: 'tab1', label: 'About the Department' },
    { id: 'tab2', label: 'Vision & Mission' },
    { id: 'tab3', label: "PEO's" },
    { id: 'tab4', label: 'POs & PSOs' },
    { id: 'tab14', label: 'Programme Offered' },
    { id: 'tab5', label: 'Laboratory Facilities' },
    { id: 'tab6', label: 'Association & Club Activities' },
    { id: 'tab7', label: "MoU's" },
    { id: 'tab8', label: 'Placement Record' },
    { id: 'tab9', label: 'Industrial Visit' },
    { id: 'tab10', label: 'Value Added Courses' },
    { id: 'tab11', label: 'Alumni' },
    { id: 'tab12', label: 'Achievements' },
    { id: 'tab13', label: 'NPTEL' },
    { id: 'tab15', label: 'Research' }
  ];

  aboutParagraphs: string[] = [
    'The Department of Computer Science & Engineering was established in the year 2011 with an intake of 60 students, with the primary objective of providing high quality education in the field of Computer Science Education.',
    'The department is committed to excellence in teaching, research, and innovation. Established with the vision of producing highly skilled professionals, it provides a strong foundation in computer science fundamentals while fostering creativity and critical thinking.',
    'The department continuously strengthens student capability through modern laboratories, research culture, industry interaction, and practical exposure in emerging technologies.'
  ];

  aboutHighlights: string[] = [
    'Academic Excellence: The curriculum is designed to align with industry trends and includes core subjects like programming, algorithms, artificial intelligence, machine learning, and cybersecurity.',
    'State-of-the-Art Facilities: The department is equipped with advanced laboratories, high-speed internet, and licensed software to support practical learning and research.',
    'Skilled Faculty: A team of experienced and dedicated faculty members contributes expertise across various domains of computer science.',
    'Industry Collaboration: Students regularly interact with industry experts through workshops, guest lectures, internships, and technical programmes.',
    'Research Focus: The department encourages students and faculty to engage in research in emerging areas such as AI, IoT, Blockchain, and Cloud Computing.',
    'Student Development: Students are motivated to participate in hackathons, coding competitions, technical symposiums, and project expos.'
  ];

  quickFacts: FactItem[] = [
    { title: 'Initial Intake', value: '60 Students' },
    { title: 'Academic Focus', value: 'Strong foundations in computing, programming, algorithms, and emerging technologies' },
    { title: 'Industry Connect', value: 'Guest lectures, internships, workshops, seminars, and collaboration with external experts' },
    { title: 'Research & Innovation', value: 'Active encouragement for projects and research in AI, IoT, Blockchain, Cloud, and related domains' }
  ];

  visionText =
    'To achieve academic excellence in Computer Science & Engineering by providing in-depth knowledge to students, inculcating research activities to meet industrial demands and societal needs, and producing quality graduates to become leaders and innovators worldwide.';

  missionPoints: string[] = [
    'To provide quality education to undergraduate and postgraduate students and make them experts in cutting-edge technology in Computer Science Engineering.',
    'To share and apply knowledge in interdisciplinary areas that extend the scope of computer science.',
    'To promote research-based innovative projects and activities in emerging technology areas.'
  ];

  peos: string[] = [
    'Apply their technical competence in Computer Science to solve real-world problems with technical and people leadership.',
    'Conduct cutting-edge research and develop solutions for problems of social relevance.',
    'Work in a business environment exhibiting team skills, work ethics, adaptability, and lifelong learning.'
  ];

  programOutcomes: OutcomeItem[] = [
    {
      title: 'Engineering Knowledge',
      description:
        'Apply the knowledge of mathematics, science, engineering fundamentals, and an engineering specialization to the solution of complex engineering problems.'
    },
    {
      title: 'Problem Analysis',
      description:
        'Identify, formulate, review research literature, and analyze complex engineering problems reaching substantiated conclusions using first principles of mathematics, natural sciences, and engineering sciences.'
    },
    {
      title: 'Design / Development of Solutions',
      description:
        'Design solutions for complex engineering problems and design system components or processes that meet specified needs with appropriate consideration for public health, safety, cultural, societal, and environmental concerns.'
    },
    {
      title: 'Conduct Investigations of Complex Problems',
      description:
        'Use research-based knowledge and research methods including design of experiments, analysis and interpretation of data, and synthesis of information to provide valid conclusions.'
    },
    {
      title: 'Modern Tool Usage',
      description:
        'Create, select, and apply appropriate techniques, resources, and modern engineering and IT tools including prediction and modeling to complex engineering activities with an understanding of limitations.'
    },
    {
      title: 'The Engineer and Society',
      description:
        'Apply reasoning informed by contextual knowledge to assess societal, health, safety, legal, and cultural issues and the consequent responsibilities relevant to professional engineering practice.'
    },
    {
      title: 'Environment and Sustainability',
      description:
        'Understand the impact of professional engineering solutions in societal and environmental contexts, and demonstrate knowledge of and need for sustainable development.'
    },
    {
      title: 'Ethics',
      description:
        'Apply ethical principles and commit to professional ethics, responsibilities, and norms of engineering practice.'
    },
    {
      title: 'Individual and Teamwork',
      description:
        'Function effectively as an individual, and as a member or leader in diverse teams and multidisciplinary settings.'
    },
    {
      title: 'Communication',
      description:
        'Communicate effectively on complex engineering activities with the engineering community and society at large through reports, design documentation, presentations, and clear instructions.'
    },
    {
      title: 'Project Management and Finance',
      description:
        'Demonstrate knowledge and understanding of engineering and management principles and apply these to individual work and team-based project management in multidisciplinary environments.'
    },
    {
      title: 'Life-long Learning',
      description:
        'Recognize the need for, and have the preparation and ability to engage in independent and life-long learning in the broadest context of technological change.'
    }
  ];

  programSpecificOutcomes: OutcomeItem[] = [
    {
      title: 'Business Solution Development',
      description:
        'Exhibit design and programming skills to build and automate business solutions using cutting-edge technologies.'
    },
    {
      title: 'Research Orientation',
      description:
        'Develop a strong theoretical foundation leading to excellence and enthusiasm toward research, enabling elegant solutions to complex problems.'
    },
    {
      title: 'Collaborative System Development',
      description:
        'Work effectively with various engineering fields as a team to design, build, and develop system applications.'
    }
  ];

  labs: LabItem[] = [
    {
      title: 'Programming Lab',
      image: 'assets/img/cse/lab3.jpeg',
      description:
        'Focuses on building foundational programming skills using languages like C, C++, Python, and Java. Supports courses such as Programming Fundamentals and Object-Oriented Programming.'
    },
    {
      title: 'Data Structures & Algorithms Lab',
      image: 'assets/img/cse/lab2.jpeg',
      description:
        'Provides hands-on experience in implementing and analyzing data structures and algorithms to solve computational problems. Supports courses like Data Structures and Algorithm Design.'
    },
    {
      title: 'Database Management Systems Lab',
      image: 'assets/img/cse/lab1.jpeg',
      description:
        'Equipped to teach database design, querying, and management using tools like Oracle, MySQL, and MongoDB. Supports the course Database Management Systems.'
    },
    {
      title: 'Operating Systems Lab',
      image: 'assets/img/cse/lab4.jpeg',
      description:
        'Offers practical exposure to operating system concepts such as process management, memory management, and file systems. Supports the course Operating Systems.'
    },
    {
      title: 'Networks and Cyber Security Lab',
      image: 'assets/img/cse/lab5.jpeg',
      description:
        'Facilitates learning of network protocols, design, and security using tools like Cisco Packet Tracer and Wireshark. Supports courses like Computer Networks and Cybersecurity.'
    },
    {
      title: 'Artificial Intelligence & Machine Learning Lab',
      image: 'assets/img/cse/lab6.jpeg',
      description:
        'Dedicated to exploring AI and ML techniques using frameworks like TensorFlow and PyTorch. Supports courses such as Artificial Intelligence and Machine Learning.'
    },
    {
      title: 'Cloud Computing and Big Data Lab',
      image: 'assets/img/cse/lab7.jpeg',
      description:
        'Provides an environment to work with cloud platforms such as AWS and Azure and big data tools like Hadoop and Spark. Supports courses like Cloud Computing and Big Data Analytics.'
    },
    {
      title: 'Web Development and Mobile Application Lab',
      image: 'assets/img/cse/lab8.jpeg',
      description:
        'Focused on designing and developing responsive websites and mobile apps using technologies like HTML, CSS, JavaScript, Android Studio, and Flutter. Supports Web Technology and Mobile Application Development.'
    }
  ];

  associationActivities: ActivityItem[] = [
    {
      sno: 1,
      activity: 'Seminar – Cyber Security',
      date: '28/08/23',
      description:
        'Seminar on Cyber Security conducted with resource persons Mr. M. Karthikeyan, SI, and Ms. K. Sudarchana, SI, Cyber Crime, Madurai.'
    },
    {
      sno: 2,
      activity: 'Full Stack Development in Python : Best Practice & Tools',
      date: '20/09/24',
      description:
        'Seminar on Full Stack Development in Python conducted with resource person Ms. Dhanu Shree, Sr. Project Engineer, Pantech, Madurai.'
    },
    {
      sno: 3,
      activity: 'Empowering Society with AI',
      date: '16/10/24',
      description:
        'Seminar on Empowering Society with AI conducted with resource person Dr. T.V. Vijaykumar, Dean, School of CS, Jawaharlal Nehru University, New Delhi.'
    },
    {
      sno: 4,
      activity: 'MERN Stack',
      date: '05/03/25',
      description:
        'Seminar on MERN Stack conducted with resource person Ms. Indhumathi, Scope Tech Software Solutions, Madurai.'
    },
    {
      sno: 5,
      activity: 'Empowering Industrial AI',
      date: '19/08/25',
      description:
        'Seminar on Empowering Industrial AI conducted with resource person Er. Sasmitha Baskaran, Founder, RAAM Techlink, Chennai.'
    },
    {
      sno: 6,
      activity: 'Open Source Excellence: Linux for Professionals',
      date: '03/09/25',
      description:
        'Seminar on Open Source Excellence: Linux for Professionals conducted with resource person Mr. C. Chellappazhani, Sr. Corporate Trainer, Winways, Madurai.'
    },
    {
      sno: 7,
      activity: 'Agentic AI',
      date: '12/02/26',
      description:
        'Seminar on Agentic AI conducted with resource person Er. Sanjay Raj S.K, Director, RECCSAR (I) Pvt. Ltd., Madurai.'
    },
    {
      sno: 8,
      activity: 'Smart Connect: Building the Future with IoT',
      date: '09/04/25',
      description:
        'Workshop on Building the Future with IoT conducted with resource person Mr. M. Karthik Raja, Embedded Software Engineer, Hi Tech Academy, Madurai.'
    },
    {
      sno: 9,
      activity: 'Django : Smart Web Solutions',
      date: '10/09/25',
      description:
        'Workshop on Django conducted with resource person Mr. V. Rajeshkannan, ASP/CSE, Kamaraj Engineering College.'
    },
    {
      sno: 10,
      activity: 'Career Opportunities for Engineering Graduates',
      date: '27/09/24',
      description:
        'Career development programme conducted with resource person Er. K. Rajmohan, Centre Director, ICA Skills Pvt. Ltd., Madurai.'
    },
    {
      sno: 11,
      activity: 'Career Guidance Program on Showcase a Better You',
      date: '20/03/24',
      description:
        'Career development programme conducted with resource person Mr. G. Vasanth, Managing Director, Ringsapp Research Pvt. Ltd., Chennai.'
    },
    {
      sno: 12,
      activity: 'Career Guidance Program on Unlocking Potential: Challenges & Opportunities in IT Industry',
      date: '18/03/25',
      description:
        'Career development programme conducted with resource person Mr. K. Srinivas, Business Development Manager, G-Tec Academy, Madurai.'
    },
    {
      sno: 13,
      activity: 'Career Guidance Program on Smart Start: Startup for Engineers',
      date: '13/10/25',
      description:
        'Career development programme conducted with resource person Er. R. Hariprasad, CEO, MarqWon Dynamics Pvt. Ltd., Madurai.'
    }
  ];

  mous: MouItem[] = [
    {
      sno: 1,
      organization: 'Chrome Software Solutions, Madurai',
      date: '03.01.2020',
      purpose: 'Internship & projects'
    },
    {
      sno: 2,
      organization: 'Pantech Pro Ed, Chennai',
      date: '15.09.2021',
      purpose: 'Placements & inplant training'
    },
    {
      sno: 3,
      organization: 'Winways Informatics, Madurai',
      date: '03.10.2022',
      purpose: 'International certification courses, internships & Research activities'
    },
    {
      sno: 4,
      organization: 'Scope Tech Solutions, Madurai',
      date: '14.09.2023',
      purpose: 'Placements & students innovative projects'
    },
    {
      sno: 5,
      organization: 'Amizhth, Chennai',
      date: '07.08.2024',
      purpose: 'Internship & placements'
    },
    {
      sno: 6,
      organization: 'Karkai Knowledge Arena Pvt. Ltd',
      date: '27.01.2025',
      purpose: 'Placements, Students innovative project, Internship'
    },
    {
      sno: 7,
      organization: 'Hebe See Technologies Pvt. Ltd, Karaikudi',
      date: '05.05.2025',
      purpose: 'Placements, Students innovative project, Internship'
    },
    {
      sno: 8,
      organization: 'Marqwon Dynamics Pvt. Ltd, Madurai',
      date: '12.11.2025',
      purpose: 'Placements, Students innovative project, Internship'
    },
    {
      sno: 9,
      organization: 'Reccsar India Pvt. Ltd., Madurai',
      date: '12.03.2026',
      purpose: 'Placements, Students innovative project, Internship'
    }
  ];
    mouPhotos: MouPhotoItem[] = [
    {
      image: 'assets/img/cse/mou1.jpeg',
      alt: 'MoU Photo 1',
      note: '27/01/25 - Karkai Knowledge Arena Pvt Ltd, Madurai'
    },
    {
      image: 'assets/img/cse/mou2.jpg',
      alt: 'MoU Photo 2',
      note: '05/05/25 - Hebe sec Technologies Pvt Ltd, Karaikudi'
    },
    {
      image: 'assets/img/cse/mou3.jpeg',
      alt: 'MoU Photo 3',
      note: '12/03/26 - Reccsar India Pvt Ltd, Madurai'
    },
    {
      image: 'assets/img/cse/mou4.jpeg',
      alt: 'MoU Photo 4',
      note: '12/11/25 - Marqwon Dynamics Pvt Ltd, Madurai'
    }
  ];

  programmes: ProgrammeItem[] = [
    {
      sno: 1,
      name: 'B.E. Computer Science & Engineering',
      duration: '4 Years'
    },
    {
      sno: 2,
      name: 'M.E. Computer Science & Engineering',
      duration: '2 Years'
    }
  ];

placementRecords: PlacementYearGroup[] = [
  {
    academicYear: '2025-2026',
    records: [
      { sno: 1, studentName: 'Aakash K', designation: 'Full Stack Python Developer Intern', companyName: 'Sourcesys Technologies Pvt Ltd' },
      { sno: 2, studentName: 'Aakash K', designation: 'Trainee Engineer', companyName: 'Besant Technologies' },
      { sno: 3, studentName: 'Ajay Selva S', designation: 'Business Associate Developer', companyName: 'Prime Vector' },
      { sno: 4, studentName: 'Ajay Selva S', designation: 'Junior Software Engineer', companyName: 'Madura Solutions' },
      { sno: 5, studentName: 'Alagar R', designation: 'Full Stack Python Developer Intern', companyName: 'Sourcesys Technologies Pvt Ltd' },
      { sno: 6, studentName: 'Anbu Selvi S', designation: 'Junior Software Engineer', companyName: 'Madura Solutions' },
      { sno: 7, studentName: 'Angel Sweety J', designation: 'Full Stack Python Developer Intern', companyName: 'Sourcesys Technologies Pvt Ltd' },
      { sno: 8, studentName: 'Bhairavi M', designation: 'Trainee Engineer', companyName: 'Besant Technologies' },
      { sno: 9, studentName: 'Hinthuja S', designation: 'Business Associate Developer', companyName: 'Prime Vector' },
      { sno: 10, studentName: 'Jegath Aswin S', designation: 'Business Associate Developer', companyName: 'Prime Vector' },
      { sno: 11, studentName: 'Hari Vignesh S', designation: 'Technical Support (Customer Support)', companyName: 'Madura Solutions' },
      { sno: 12, studentName: 'John Mohamed A', designation: 'Full Stack Python Developer Intern', companyName: 'Sourcesys Technologies Pvt Ltd' },
      { sno: 13, studentName: 'John Mohamed A', designation: 'Trainee Engineer', companyName: 'Besant Technologies' },
      { sno: 14, studentName: 'John Mohamed A', designation: 'Junior Software Engineer', companyName: 'Madura Solutions' },
      { sno: 15, studentName: 'Kamali Sri M', designation: 'Trainee Engineer', companyName: 'Besant Technologies' },
      { sno: 16, studentName: 'Kamali Sri M', designation: 'Junior Software Engineer', companyName: 'Madura Solutions' },
      { sno: 17, studentName: 'Karthck M', designation: 'Junior Software Engineer', companyName: 'Madura Solutions' },
      { sno: 18, studentName: 'Kiruthika S', designation: 'Business Associate Developer', companyName: 'Prime Vector' },
      { sno: 19, studentName: 'Karuppusamy M', designation: 'Technical Support (Customer Support)', companyName: 'Madura Solutions' },
      { sno: 20, studentName: 'Koori Ilangumaran K', designation: 'Full Stack Python Developer Intern', companyName: 'Sourcesys Technologies Pvt Ltd' },
      { sno: 21, studentName: 'Mahalakshmi S', designation: 'Business Associate Developer', companyName: 'Prime Vector' },
      { sno: 22, studentName: 'Mahalakshmi S', designation: 'Junior Software Engineer', companyName: 'Madura Solutions' },
      { sno: 23, studentName: 'Mahalakshmi T', designation: 'Data Scientist Intern', companyName: 'Sourcesys Technologies Pvt Ltd' },
      { sno: 24, studentName: 'Mahalakshmi T', designation: 'Trainee Engineer', companyName: 'Besant Technologies' },
      { sno: 25, studentName: 'Manohar Sai Shree M', designation: 'Junior Software Engineer', companyName: 'Madura Solutions' },
      { sno: 26, studentName: 'Mathan Kumar N', designation: 'Full Stack Python Developer Intern', companyName: 'Sourcesys Technologies Pvt Ltd' },
      { sno: 27, studentName: 'Mathan Kumar N', designation: 'Business Associate Developer', companyName: 'Prime Vector' },
      { sno: 28, studentName: 'Mathan Kumar N', designation: 'Trainee Engineer', companyName: 'Besant Technologies' },
      { sno: 29, studentName: 'Mohamed Sheik Yousuf N', designation: 'Trainee Engineer', companyName: 'Besant Technologies' },
      { sno: 30, studentName: 'Mohammed Sheik Yusuf', designation: 'Full Stack Python Developer Intern', companyName: 'Madura Solutions' },
      { sno: 31, studentName: 'Monica R', designation: 'Junior Software Engineer', companyName: 'Madura Solutions' },
      { sno: 32, studentName: 'Nivetha A', designation: 'Junior Software Engineer', companyName: 'Madura Solutions' },
      { sno: 33, studentName: 'Prime Vector', designation: 'Business Associate Developer', companyName: 'Prime Vector' },
      { sno: 34, studentName: 'Norul Thahseena A', designation: 'Trainee Engineer', companyName: 'Besant Technologies' },
      { sno: 35, studentName: 'Norul Thahseena A', designation: 'Junior Software Engineer-Trainee', companyName: 'Dotnix Technologies' },
      { sno: 36, studentName: 'Pavithra K', designation: 'Full Stack Python Developer Intern', companyName: 'Sourcesys Technologies Pvt Ltd' },
      { sno: 37, studentName: 'Pooja Shri S', designation: 'Junior Software Engineer', companyName: 'Madura Solutions' },
      { sno: 38, studentName: 'Ranjith R', designation: 'Business Associate Developer', companyName: 'Prime Vector' },
      { sno: 39, studentName: 'Ranjith R', designation: 'Technical Support (Customer Support)', companyName: 'Madura Solutions' },
      { sno: 40, studentName: 'Sanjay Devan K R', designation: 'Full Stack Python Developer Intern', companyName: 'Sourcesys Technologies Pvt Ltd' },
      { sno: 41, studentName: 'Sanjay Devan K R', designation: 'Junior Software Engineer-Trainee', companyName: 'Dotnix Technologies' },
      { sno: 42, studentName: 'Saravanan M', designation: 'Full Stack Python Developer Intern', companyName: 'Sourcesys Technologies Pvt Ltd' },
      { sno: 43, studentName: 'Sathya', designation: 'Business Associate Developer', companyName: 'Prime Vector' },
      { sno: 44, studentName: 'Shahul Hameed M', designation: 'Junior Software Engineer-Trainee', companyName: 'Madura Solutions' },
      { sno: 45, studentName: 'Shalini R S', designation: 'Full Stack Python Developer Intern', companyName: 'Sourcesys Technologies Pvt Ltd' },
      { sno: 46, studentName: 'Shalini S', designation: 'Junior Software Engineer', companyName: 'Madura Solutions' },
      { sno: 47, studentName: 'Sona G', designation: 'Technical Support (Customer Support)', companyName: 'Madura Solutions' },
      { sno: 48, studentName: 'Visalini V', designation: 'Full Stack Python Developer Intern', companyName: 'Sourcesys Technologies Pvt Ltd' }
    ]
  }
];

  industrialVisitPhotos: ActivityPhotoItem[] = [];
  industrialVisitNotes: string[] = [];


  valueAddedCourses: ValueAddedCourseItem[] = [
    {
      sno: 1,
      courseName: 'CSGAI26 - Generative AI Project – Bootcamp',
      description:
        'Conducted by Ms. P. Akshaya and Ms. J. S. Suvathipriya, Technical Team, RAMTech link Pvt. Ltd., Chennai.',
      duration: '05.01.2026 to 09.01.2026'
    },
    {
      sno: 2,
      courseName: 'CSJSB26 – Java Spring Boot',
      description:
        'Conducted by Mr. P. Parthiban, Technical Head, ScopeTech Solutions, Madurai.',
      duration: '05.01.2026 to 09.01.2026'
    },
        {
      sno: 3,
      courseName: 'CSFSP25 - Full Stack Development in Python ',
      description:
        'Conducted by Mr. Dhanushree, Project Developer, PanTech, Madurai',
      duration: '04.02.2025 to 28.02.2025'
    },
        {
      sno: 4,
      courseName: 'CSFSJ25 – Full Stack Development in Java',
      description:
        'Conducted by Mr. Subash, Sr.Technical Specialist, Amizth Techno Solutions, Chennai.',
      duration: '04.02.2025 to 28.02.2025'
    }

  ];

  valueAddedCoursePhotos: ActivityPhotoItem[] = [
    {
      image: 'assets/img/cse/v1.png',
      alt: 'Value Added Course Photo 1'
    },
    {
      image: 'assets/img/cse/v2.png',
      alt: 'Value Added Course Photo 2'
    },
       {
      image: 'assets/img/cse/v3.png',
      alt: 'Value Added Course Photo 3'
    },
    {
      image: 'assets/img/cse/v4.png',
      alt: 'Value Added Course Photo 4'
    },

  ];

  alumniRecords: AlumniItem[] = [];
  distinguishedAlumniProfiles: DistinguishedAlumniItem[] = [
  {
    image: 'assets/img/cse/Haritha Shree.png',
    alt: 'Distinguished Alumni - Haritha Shree S',
    name: 'Haritha Shree S',
    batch: '2018-2022',
    workingAddress: 'Infosys Mysore',
    position: 'System Engineer'
  },
  {
    image: 'assets/img/cse/Ajay.png',
    alt: 'Distinguished Alumni - Ajay R',
    name: 'Ajay R',
    batch: '2018-2022',
    workingAddress: 'Wipro Technologies Bangalore',
    position: 'Cyber Security Analyst'
  },
  {
    image: 'assets/img/cse/Nivetha Jessintha K.png',
    alt: 'Distinguished Alumni - Nivetha Jessintha K',
    name: 'Nivetha Jessintha K',
    batch: '2016-2020',
    workingAddress: 'Hexaware Chennai',
    position: 'Senior System Engineer'
  },
  {
    image: 'assets/img/cse/Sugash P M.png',
    alt: 'Distinguished Alumni - Sugash P M',
    name: 'Sugash P M',
    batch: '2016-2020',
    workingAddress: 'TCS Bangalore',
    position: 'System Engineer'
  },
  {
    image: 'assets/img/cse/Lamisha Reva S K.png',
    alt: 'Distinguished Alumni - Lamisha Reva S K',
    name: 'Lamisha Reva S K',
    batch: '2014-2018',
    workingAddress: 'CTS Hyderabad',
    position: 'Analyst'
  },
  {
    image: 'assets/img/cse/Sarath Kumar R.png',
    alt: 'Distinguished Alumni - Sarath Kumar R',
    name: 'Sarath Kumar R',
    batch: '2013-2017',
    workingAddress: 'TCS Bangalore',
    position: 'QET Functional Analyst'
  },
  {
    image: 'assets/img/cse/Balasubramanian S.png',
    alt: 'Distinguished Alumni - Balasubramanian S',
    name: 'Balasubramanian S',
    batch: '2016-2020',
    workingAddress: 'ABB Global Industries & Private Limited Bangalore',
    position: 'Associate R&D Engineer'
  },
  {
    image: 'assets/img/cse/Ajith Kumar K.png',
    alt: 'Distinguished Alumni - Ajith Kumar K',
    name: 'Ajith Kumar K',
    batch: '2015-2019',
    workingAddress: "Lowe's Service Limited Bangalore",
    position: 'Software Engineer'
  }
];
achievements: AchievementItem[] = [
  {
    sno: 1,
    studentNames: ['Kathirava Pandian S - III Year'],
    eventName: 'UI Battle',
    collegeName: 'Solamalai Engg College',
    level: 'Intercollegiate',
    eventDate: '07/02/2026',
    awardName: '1st Prize'
  },
  {
    sno: 2,
    studentNames: ['Vignesh G - III Year'],
    eventName: 'UI Battle',
    collegeName: 'Solamalai Engg College',
    level: 'Intercollegiate',
    eventDate: '07/02/2026',
    awardName: '1st Prize'
  },
  {
    sno: 3,
    studentNames: ['Prem K - II Year'],
    eventName: 'UI Battle',
    collegeName: 'Solamalai Engg College',
    level: 'Intercollegiate',
    eventDate: '07/02/2026',
    awardName: '2nd Prize'
  },
  {
    sno: 4,
    studentNames: ['Sabareeswaran K - II Year'],
    eventName: 'UI Battle',
    collegeName: 'Solamalai Engg College',
    level: 'Intercollegiate',
    eventDate: '07/02/2026',
    awardName: '2nd Prize'
  },
  {
    sno: 5,
    studentNames: ['Sanjith S - II Year'],
    eventName: 'T60',
    collegeName: 'Solamalai Engg College',
    level: 'Intercollegiate',
    eventDate: '07/02/2026',
    awardName: '3rd Prize'
  },
  {
    sno: 6,
    studentNames: ['Hinduja S - IV Year'],
    eventName: 'Play Music',
    collegeName: 'Ultra College of Engg',
    level: 'Intercollegiate',
    eventDate: '24/10/2025',
    awardName: '2nd Prize'
  },
  {
    sno: 7,
    studentNames: ['Poornima T - IV Year'],
    eventName: 'Echo meme',
    collegeName: 'Ultra College of Engg',
    level: 'Intercollegiate',
    eventDate: '24/10/2025',
    awardName: '3rd Prize'
  },
  {
    sno: 8,
    studentNames: ['Aspar Nisha A - III Year'],
    eventName: 'Paper Presentation',
    collegeName: 'KLN College of Engg',
    level: 'Intercollegiate',
    eventDate: '12/09/2025',
    awardName: '1st Prize'
  },
  {
    sno: 9,
    studentNames: ['Nashrin Banu S - III Year'],
    eventName: 'Paper Presentation',
    collegeName: 'KLN College of Engg',
    level: 'Intercollegiate',
    eventDate: '12/09/2025',
    awardName: '1st Prize'
  },
  {
    sno: 10,
    studentNames: ['Aspar Nisha A - III Year'],
    eventName: 'Quiz',
    collegeName: 'KLN College of Engg',
    level: 'Intercollegiate',
    eventDate: '12/09/2025',
    awardName: '2nd Prize'
  },
  {
    sno: 11,
    studentNames: ['Nashrin Banu S - III Year'],
    eventName: 'Quiz',
    collegeName: 'KLN College of Engg',
    level: 'Intercollegiate',
    eventDate: '12/09/2025',
    awardName: '2nd Prize'
  },
  {
    sno: 12,
    studentNames: ['Yuvaraj - III Year'],
    eventName: 'Silambam',
    collegeName: 'CM Trophy 2025',
    level: 'State Level',
    eventDate: '12/09/2025',
    awardName: 'Gold Medal'
  },
  {
    sno: 13,
    studentNames: ['Karthirava Pandian S - III Year'],
    eventName: 'UI/UX',
    collegeName: 'Mangaiyarkarasi Engg college',
    level: 'Intercollegiate',
    eventDate: '26/08/2025',
    awardName: '1st Prize'
  },
  {
    sno: 14,
    studentNames: ['Bharanidharan S - III Year'],
    eventName: 'UI/UX',
    collegeName: 'Mangaiyarkarasi Engg college',
    level: 'Intercollegiate',
    eventDate: '26/08/2025',
    awardName: '1st Prize'
  },
  {
    sno: 15,
    studentNames: ['Prakash R - III Year'],
    eventName: 'UI/UX',
    collegeName: 'Mangaiyarkarasi Engg college',
    level: 'Intercollegiate',
    eventDate: '26/08/2025',
    awardName: '1st Prize'
  },
  {
    sno: 16,
    studentNames: ['Nashrin Banu S - III Year'],
    eventName: 'Technoverse',
    collegeName: 'Mangaiyarkarasi Engg college',
    level: 'Intercollegiate',
    eventDate: '26/08/2025',
    awardName: '3rd Prize'
  },
  {
    sno: 17,
    studentNames: ['Kanjana S - III Year'],
    eventName: 'Technoverse',
    collegeName: 'Mangaiyarkarasi Engg college',
    level: 'Intercollegiate',
    eventDate: '26/08/2025',
    awardName: '3rd Prize'
  },
  {
    sno: 18,
    studentNames: ['Rasitha C - III Year'],
    eventName: 'Technoverse',
    collegeName: 'Mangaiyarkarasi Engg college',
    level: 'Intercollegiate',
    eventDate: '26/08/2025',
    awardName: '3rd Prize'
  },
  {
    sno: 19,
    studentNames: ['Poornima T - IV Year'],
    eventName: 'Poster Presenation',
    collegeName: 'Mangaiyarkarasi Engg college',
    level: 'Intercollegiate',
    eventDate: '26/08/2025',
    awardName: '2nd Prize'
  },
  {
    sno: 20,
    studentNames: ['Kanishka K - IV Year'],
    eventName: 'Poster Presenation',
    collegeName: 'Mangaiyarkarasi Engg college',
    level: 'Intercollegiate',
    eventDate: '26/08/2025',
    awardName: '2nd Prize'
  },
  {
    sno: 21,
    studentNames: ['Manjari S - IV Year'],
    eventName: 'Poster Presenation',
    collegeName: 'Mangaiyarkarasi Engg college',
    level: 'Intercollegiate',
    eventDate: '26/08/2025',
    awardName: '2nd Prize'
  },
  {
    sno: 22,
    studentNames: ['Kanishka S - IV Year'],
    eventName: 'Poster Presenation',
    collegeName: 'Mangaiyarkarasi Engg college',
    level: 'Intercollegiate',
    eventDate: '26/08/2025',
    awardName: '2nd Prize'
  },
  {
    sno: 23,
    studentNames: ['Sharmila Devi S - III Year'],
    eventName: 'Data Decode',
    collegeName: 'Mangaiyarkarasi Engg college',
    level: 'Intercollegiate',
    eventDate: '26/08/2025',
    awardName: '3rd Prize'
  },
  {
    sno: 24,
    studentNames: ['Karthiga S - III Year'],
    eventName: 'Data Decode',
    collegeName: 'Mangaiyarkarasi Engg college',
    level: 'Intercollegiate',
    eventDate: '26/08/2025',
    awardName: '3rd Prize'
  },
  {
    sno: 25,
    studentNames: ['Poornima T - IV Year'],
    eventName: 'Six Legged',
    collegeName: 'Mangaiyarkarasi Engg college',
    level: 'Intercollegiate',
    eventDate: '26/08/2025',
    awardName: '3rd Prize'
  },
  {
    sno: 26,
    studentNames: ['Kanishka S - IV Year'],
    eventName: 'Six Legged',
    collegeName: 'Mangaiyarkarasi Engg college',
    level: 'Intercollegiate',
    eventDate: '26/08/2025',
    awardName: '3rd Prize'
  },
  {
    sno: 27,
    studentNames: ['Manjari S - IV Year'],
    eventName: 'Six Legged',
    collegeName: 'Mangaiyarkarasi Engg college',
    level: 'Intercollegiate',
    eventDate: '26/08/2025',
    awardName: '3rd Prize'
  },
  {
    sno: 28,
    studentNames: ['Kanishka S - IV Year'],
    eventName: 'Six Legged',
    collegeName: 'Mangaiyarkarasi Engg college',
    level: 'Intercollegiate',
    eventDate: '26/08/2025',
    awardName: '3rd Prize'
  },
  {
    sno: 29,
    studentNames: ['Bhairavi M - III Year'],
    eventName: 'Paper Presentation',
    collegeName: 'Kamaraj Engg College',
    level: 'Intercollegiate',
    eventDate: '03/03/2025',
    awardName: '1st Prize'
  },
  {
    sno: 30,
    studentNames: ['Noorul Thanseena A - III Year'],
    eventName: 'Paper Presentation',
    collegeName: 'Kamaraj Engg College',
    level: 'Intercollegiate',
    eventDate: '03/03/2025',
    awardName: '1st Prize'
  },
  {
    sno: 31,
    studentNames: ['Anbu Selvi S - III Year'],
    eventName: 'Code Beat',
    collegeName: 'SIT',
    level: 'Intercollegiate',
    eventDate: '25/02/2025',
    awardName: '2nd Prize'
  },
  {
    sno: 32,
    studentNames: ['Ajay Selva S - III Year'],
    eventName: 'Cricket Bidders',
    collegeName: 'Solamalai Engg College',
    level: 'Intercollegiate',
    eventDate: '11/01/2025',
    awardName: '1st Prize'
  },
  {
    sno: 33,
    studentNames: ['Sabari P - III Year'],
    eventName: 'Cricket Bidders',
    collegeName: 'Solamalai Engg College',
    level: 'Intercollegiate',
    eventDate: '11/01/2025',
    awardName: '1st Prize'
  },
  {
    sno: 34,
    studentNames: ['Hari vignesh S - III Year'],
    eventName: 'Cricket Bidders',
    collegeName: 'Solamalai Engg College',
    level: 'Intercollegiate',
    eventDate: '11/01/2025',
    awardName: '1st Prize'
  }
];
  achievementPhotos: ActivityPhotoItem[] = [];
  achievementPhotoNotes: string[] = [];

  nptelRecords: NptelRecordItem[] = [
    {
      staffName: 'Dr. P. Ravikumaran',
      subject: 'Cyber Security and Privacy',
      grade: 'Elite',
      session: 'Apr 2025'
    },
    {
      staffName: 'Dr. P. Ravikumaran',
      subject: 'OBE and Accreditation',
      grade: 'Elite + Silver',
      session: 'Oct 2025'
    },
    {
      staffName: 'Dr. P. Ravikumaran',
      subject: 'Business Intelligence & Analytics',
      grade: 'Pass',
      session: 'Aug 2023'
    },
    {
      staffName: 'Dr. P. Ravikumaran',
      subject: 'Outcome Based Pedagogic Principles For Effective Teaching',
      grade: 'Silver Elite',
      session: 'Aug 2023'
    },
    {
      staffName: 'Mr. G. Balakrishnan',
      subject: 'Programming in Java',
      grade: 'Elite',
      session: 'May 2024'
    },
    {
      staffName: 'Mr. G. Balakrishnan',
      subject: 'Data Science using Python',
      grade: 'Elite + Silver',
      session: 'Aug 2023'
    },
    {
      staffName: 'Mr. G. Balakrishnan',
      subject: 'OBE and Accreditation',
      grade: 'Elite + Silver',
      session: 'Oct 2025'
    },
    {
      staffName: 'Ms. R. Sudha',
      subject: 'Cloud Computing',
      grade: 'Silver Elite',
      session: 'Aug 2023'
    },
    {
      staffName: 'Ms. K. Preethi',
      subject: 'Fundamentals of Artificial Intelligence',
      grade: 'Pass',
      session: 'Aug 2023'
    },
    {
      staffName: 'Ms. K. Preethi',
      subject: 'Data analytics with Python',
      grade: 'Elite',
      session: 'Aug 2023'
    },
    {
      staffName: 'Ms. T. Mangaiyarkarasi',
      subject: 'OBE and Accreditation',
      grade: 'Elite + Silver',
      session: 'Oct 2025'
    },
    {
      staffName: 'Ms. T. Mangaiyarkarasi',
      subject: 'Machine Learning & Deep Learning Application',
      grade: 'Pass',
      session: 'Oct 2025'
    },
    {
      staffName: 'Ms. T. Mangaiyarkarasi',
      subject: 'Cyber Security',
      grade: 'Elite',
      session: 'Oct 2025'
    },
    {
      staffName: 'Ms. T. Mangaiyarkarasi',
      subject: 'Cloud Computing',
      grade: 'Pass',
      session: 'Apr 2025'
    },
    {
      staffName: 'Ms. T. Mangaiyarkarasi',
      subject: 'Deep Learning',
      grade: 'Elite',
      session: 'Apr 2025'
    },
    {
      staffName: 'Ms. T. Mangaiyarkarasi',
      subject: 'Data Analytics using Python',
      grade: 'Elite',
      session: 'Aug 2023'
    },
    {
      staffName: 'Ms. K. Sangeetha',
      subject: 'Advanced Computer Networks',
      grade: 'Pass',
      session: 'Apr 2025'
    },
    {
      staffName: 'Ms. P. K. Salomi Victoria',
      subject: 'OBE and Accreditation',
      grade: 'Elite',
      session: 'Oct 2025'
    },
    {
      staffName: 'Ms. IG. Uma Maheswari',
      subject: 'OBE and Accreditation',
      grade: 'Elite',
      session: 'Oct 2025'
    },
    {
      staffName: 'Ms. S. Vinothini',
      subject: 'OBE and Accreditation',
      grade: 'Elite + Silver',
      session: 'Oct 2025'
    }
  ];
alumniPhotos: AlumniPhotoItem[] = [
  {
    image: 'assets/img/cse/a1.jpg',
    alt: 'Alumni Interaction Photo 1',
    note: '28/10/24 - Er. M. Sathya | Batch: 2017-21 | Software Developer, Jasyskay Tech, Madurai'
  },
  {
    image: 'assets/img/cse/a4.jpeg',
    alt: 'Alumni Interaction Photo 2',
    note: '22/03/24 - Er. K. Sridevi | Batch: 2014-18 | Freelancer, IT Solutions, Chennai'
  },
  {
    image: 'assets/img/cse/a2.jpg',
    alt: 'Alumni Interaction Photo 3',
    note: '26/02/25 - Er. K. Nivetha Jessintha | Batch: 2016-20 | Sr. System Engineer, Hexaware, Chennai'
  },
  {
    image: 'assets/img/cse/a3.jpg',
    alt: 'Alumni Interaction Photo 4',
    note: '12/08/25 - Er. A. Suriya Prakash | Batch: 2015-19 | Sr. Developer, Lowe’s, Blore'
  }
];
industrialVisits: IndustrialVisitItem[] = [
  {
    sno: 1,
    date: '20/10/23',
    industry: 'HCL Tech, Madurai',
    studentsBenefitted: 40,
    image: 'assets/img/cse/iv1.jpg',
    alt: 'Industrial Visit to HCL Tech, Madurai'
  },
  {
    sno: 2,
    date: '21/10/24',
    industry: 'ISRO, Mahendragiri',
    studentsBenefitted: 51,
    image: 'assets/img/cse/iv2.jpg',
    alt: 'Industrial Visit to ISRO, Mahendragiri'
  },
    {
    sno: 3,
    date: '12/03/25',
    industry: 'TechnoSoft Solutions, Banglore',
    studentsBenefitted: 53,
    image: 'assets/img/cse/iv3.jpeg',
    alt: 'Industrial Visit to TechnoSoft Solutions, Banglore'
  },
  {
    sno: 4,
    date: '04/03/26',
    industry: 'RECCSAR India Pvt. Ltd., Madurai',
    studentsBenefitted: 44,
    image: 'assets/img/cse/iv4.png',
    alt: 'Industrial Visit to RECCSAR India Pvt. Ltd., Madurai'
  }
];
journalPublications: JournalPublicationItem[] = [
  {
    sno: 1,
    authors: ['Dr. P. Ravikumaran'],
    title: 'A Hybrid CNN-LSTM Approach for Enhanced Prediction of CKD Disease using Deep Learning & Big data',
    journalName: 'International Research Journal on Advanced Engineering Hub',
    issueVolume: 'Volume 03, Issue 3',
    monthYear: 'March 2025'
  },
  {
    sno: 2,
    authors: [
      'Mr. G. Balakrishnan',
      'Ms. T. Mangaiyarkarasi',
      'Ms. K. Sangeetha',
      'Ms. M. Rathika'
    ],
    title: 'Hand Gestures for Object Movements : A Comprehensive Exploration',
    journalName: 'International Journal of Innovative Science, Research & Technology',
    issueVolume: 'Volume 10, Issue 7',
    monthYear: 'July 2025'
  },
  {
    sno: 3,
    authors: [
      'Mr. G. Balakrishnan',
      'Ms. T. Mangaiyarkarasi',
      'Ms. S. Vinothini',
      'Ms. IG. Umamaheswari'
    ],
    title: 'Generative AI in education: transformative innovations',
    journalName: 'International Research journal of modernization in Engg , Tech & Science',
    issueVolume: 'Volume 7, issue 12',
    monthYear: 'Dec 2025'
  }
];

conferenceRecords: ConferenceItem[] = [
  {
    sno: 1,
    conferenceName: 'AICTE Sponsorted ATAL VAANI 2026',
    paperTitle: 'AI driven Automation for Inventory management system',
    authors: ['Dr. P. Ravikumaran'],
    collegeName: 'SRM Madurai College of Engg & Tech',
    date: '18/12/26'
  },
  {
    sno: 2,
    conferenceName: 'AICTE Sponsorted ATAL VAANI 2026',
    paperTitle: 'A Stakeholder –centered road map for AI ethics in education :Governance and implementation',
    authors: [
      'Mr. G. Balakrishnan',
      'Ms. Vinothini',
      'Ms. K. Sangeetha',
      'Ms. T. Mangaiyarkarasi',
      'Ms. S. Vinothini'
    ],
    collegeName: 'SRM Madurai College of Engg & Tech',
    date: '18/12/26'
  },
  {
    sno: 3,
    conferenceName: 'AICTE Sponsorted ATAL VAANI 2026',
    paperTitle: 'Educational data mining and learning analytics: A contemporary exploration',
    authors: [
      'Mr. G. Balakrishnan',
      'Ms. T. Mangaiyarkarai',
      'Ms. T. Umamaheswari',
      'Ms. P.K. Salomi victoria'
    ],
    collegeName: 'SRM Madurai College of Engg & Tech',
    date: '18/12/26'
  },
  {
    sno: 4,
    conferenceName: 'International Conference on Emerging Trends in Intelligence & Computing 2025',
    paperTitle: 'A Hybrid CNN-LSTM Approach for Enhanced Prediction of CKD Disease using Deep Learning & Big da',
    authors: ['Dr. P. Ravikumaran'],
    collegeName: 'St. Xaviers College of Engg & Management, Patna',
    date: '12/2/2025'
  }
];

fundReceivedRecords: FundReceivedItem[] = [
  {
    sno: 1,
    staffName: 'Dr. P. Ravikumaran',
    amount: 'Rs. 10,000',
    source: 'Naan Mudhalvan’s Niral Thiruvizha 2.0',
    date: '13/02/2026',
    purpose: 'Innovative Project solution'
  }
];

patentRecords: PatentItem[] = [
  {
    sno: 1,
    academicYear: '2021-2022',
    name: 'Dr. P. Ravikumaran HoD/CSE',
    category: 'Patent',
    inventionTitle: 'Automatic Detection device to prevent the disease in turmeric plant leave using CNN Enabled IOT',
    applicationNumber: '202114107237 A',
    publicationDate: '17/12/2021',
    status: 'Published'
  },
  {
    sno: 2,
    academicYear: '2024-2025',
    name: 'Mr. G. Balakrishnan ASP/CSE',
    category: 'Patent',
    inventionTitle: 'Location of tweet prediction using Machine Learning Techniques',
    applicationNumber: '202441012000A',
    publicationDate: '8/8/3/2024',
    status: 'Published'
  },
  {
    sno: 3,
    academicYear: '2024-2025',
    name: 'Dr. P. Ravikumaran HoD/CSE',
    category: 'Patent',
    inventionTitle: 'ADOPTIVE AI POWERED TUTORING AND LEARNING FOR ALL AGES',
    applicationNumber: '202541009836 A',
    publicationDate: '14/02/2025',
    status: 'Published'
  }
];
universityRankHolders: UniversityRankHolderItem[] = [
  {
    batch: '2021-23',
    name: 'Er. K. Ajith Kumar, M.E CSE',
    rank: '10th Rank',
    photo: 'assets/img/cse/ajith-kumar.png',
    alt: 'Er. K. Ajith Kumar, M.E CSE'
  },
  {
    batch: '2016-18',
    name: 'Er. R. Meenakshi Priya, M.E CSE',
    rank: '46th Rank',
    photo: 'assets/img/cse/meenakshi-priya.jpg',
    alt: 'Er. R. Meenakshi Priya, M.E CSE'
  },
  {
    batch: '2016-18',
    name: 'Er. C. Shanmuga Priya, M.E CSE',
    rank: '48th Rank',
    photo: 'assets/img/cse/shanmuga-priya.jpg',
    alt: 'Er. C. Shanmuga Priya, M.E CSE'
  },
  {
    batch: '2012-14',
    name: 'Er. S. Maria Sobana, M.E CSE',
    rank: '46th Rank',
    photo: 'assets/img/cse/maria-sobana.jpg',
    alt: 'Er. S. Maria Sobana, M.E CSE'
  }
];
  constructor(public themeService: ThemeCustomizerService) {
    this.themeService.isToggled$.subscribe((isToggled) => {
      this.isToggled = isToggled;
    });
  }

  get activeTabLabel(): string {
    return this.tabs.find((tab) => tab.id === this.selectedTab)?.label || 'Department Profile';
  }

  toggleTheme(): void {
    this.themeService.toggleTheme();
  }

  selectTab(tab: string): void {
    this.selectedTab = tab;
  }

  ngOnInit(): void {}
}